import React from "react";
import AggregatorResult from "./AggregatorResult";

const AggregatorSuccessful = () => {
  return <AggregatorResult variant="success" />;
};

export default AggregatorSuccessful;
